import { useState, useEffect, useCallback, useMemo } from 'react';
import { filterScenarios, scenarioScopeTotal } from '../models/LibraryModel';

/**
 * ViewModel for Settings > Assessments (PRD-1701). Scenarios live in the
 * shared LibraryModel beside the documents they pick from, so the Library's
 * "Used by" follows every save and archive.
 */
export const useScenariosViewModel = (model) => {
  const [state, setState] = useState(() => model.getState());

  useEffect(() => {
    setState(model.getState());
    return model.subscribe(setState);
  }, [model]);

  const { documents, scenarioFilters: filters } = state;
  const scenarios = useMemo(() => state.scenarios || [], [state.scenarios]);

  const visibleScenarios = useMemo(
    () => filterScenarios(scenarios, documents, filters),
    [scenarios, documents, filters],
  );
  // The "of N": the scenarios the visibility filter is looking at, before the search.
  const scopeTotal = useMemo(
    () => scenarioScopeTotal(scenarios, filters.visibility),
    [scenarios, filters.visibility],
  );

  const setFilter = useCallback((key, value) => model.setScenarioFilter(key, value), [model]);
  const clearFilters = useCallback(() => model.clearScenarioFilters(), [model]);
  const setSort = useCallback((sort) => model.setScenarioSort(sort), [model]);
  const saveScenario = useCallback((fields) => model.saveScenario(fields), [model]);
  const archive = useCallback((id) => model.archiveScenario(id), [model]);
  const unarchive = useCallback((id) => model.unarchiveScenario(id), [model]);

  return {
    // False for the moment between the flag turning on and the scenarios arriving.
    ready: state.scenarios !== null,
    documents,
    scenarios,
    visibleScenarios,
    scopeTotal,
    filters,
    setFilter,
    sort: state.scenarioSort,
    setSort,
    clearFilters,
    saveScenario,
    archive,
    unarchive,
  };
};
